<template>

  <div>
    <!-- Modal -->
    <div v-once class="modal" v-bind:id=dialogId tabindex="-1" role="dialog">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Rechte von <i>{{ getHeadline }}</i></h5>
            <button type="button" class="close" @click="clickClose" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <UserPermissionTable :id=this.$props.id :payload="this.$props.payload"></UserPermissionTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import UserPermissionTable from './UserPermissionTable'
  /* global $ */
  export default {
    props: ['id', 'payload', 'context'],
    data () {
      return {
        dialogId: 'userpermissionDialog'
      }
    },
    components: {
      UserPermissionTable
    },
    methods: {
      clickClose () {
        $('#' + this.dialogId).modal('hide')
        // this.$router.push({ name: 'user' })
      }
    },
    mounted () {
      var dialogId = this.dialogId
      var router = this.$router
      var context = this.$props.context
      $(document).ready(function () {
        $('#' + dialogId).modal('show')

        $('#' + dialogId).on('hidden.bs.modal', function (e) {
          router.push({ name: context })
        })
      })
    },
    computed: {
      getHeadline () {
        return this.$props.payload.sLastname + ', ' + this.$props.payload.sFirstname
      }
    }
  }
</script>
<style>

</style>
